// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"521bb0d8f717e985e087","655":"2bb0c872f2f3dd6f1e9a"}[chunkId] + ".js";
};